import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrailerService {
  api_url = environment.url;

  constructor(private http: HttpClient) { }

  listTrailer() {
    return this.http.get(`${this.api_url}trailer/list`);
  }

  getCombo() {
    return this.http.get(`${this.api_url}trailer/getCombo`);
  }

  getId(id: number) {
    return this.http.get(`${this.api_url}trailer/show/${id}`);
  }

  addTrailer(data: any) {
    return this.http.post(`${this.api_url}trailer/add`, data);
  }

  updateTrailer(data: any, id: number) {
    return this.http.post(`${this.api_url}trailer/update/${id}`, data);
  }

  deleteTrailer(id: any) {
    return this.http.get(`${this.api_url}trailer/delete/${id}`);
  }

  getTrailerTypes() {
    return this.http.get(`${this.api_url}trailer/types`);
  }
}
